var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAbsChallengeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.22882 15.1905L4.55941 13.9398L5.44108 13.4679L6.11049 14.7186C6.18649 14.8606 6.33449 14.9493 6.49555 14.9493H9.52092C9.68371 14.9493 9.833 14.8587 9.90823 14.7144L10.5553 13.4728L11.4421 13.9349L10.795 15.1765C10.5475 15.6514 10.0565 15.9493 9.52092 15.9493H6.49555C5.9657 15.9493 5.47885 15.6577 5.22882 15.1905Z",
    fill: "#414141"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.60372 3.28708C4.92039 -1.04055 11.1306 -1.02462 13.4251 3.31485L14.4694 5.28994C14.6798 5.68786 14.4806 6.17932 14.0525 6.3185L12.7735 6.7344C12.3836 6.86119 11.9563 6.72358 11.7136 6.39306L11.2243 5.72655C9.63531 3.56224 6.40813 3.54505 4.79618 5.69231L4.34485 6.29353C4.11631 6.59797 3.72813 6.73665 3.35842 6.64593L2.00956 6.31498C1.54966 6.20214 1.31956 5.68596 1.54304 5.26848L2.60372 3.28708ZM12.541 3.78227C10.621 0.150849 5.42402 0.137513 3.48535 3.75903L2.59182 5.42818L3.56483 5.66692L3.99645 5.09195C6.01108 2.40828 10.0445 2.42976 12.0304 5.13475L12.4985 5.7723L13.4326 5.46854L12.541 3.78227Z",
    fill: "#414141"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.40729 8.64785L2.61708 8.90552L3.87549 12.8464C3.9333 13.0274 4.10152 13.1503 4.29155 13.1503H11.6952C11.8845 13.1503 12.0523 13.0283 12.1107 12.8482L13.3879 8.9071L12.602 8.65491L12.5874 8.7105L12.1037 8.58422L12.5869 8.71272C11.3399 13.4014 4.68161 13.4143 3.43263 8.72572L3.40729 8.64785ZM4.61634 9.08422C5.90103 11.9516 10.1054 11.9541 11.3981 9.08422H8.01321V8.08422H11.7185C11.8391 7.70452 12.247 7.49078 12.6309 7.61399L13.9559 8.03914C14.338 8.16175 14.5478 8.5714 14.4241 8.95316L13.062 13.1565C12.87 13.749 12.318 14.1503 11.6952 14.1503H4.29155C3.66642 14.1503 3.11304 13.7461 2.92288 13.1506L1.58137 8.94948C1.46007 8.56962 1.66824 8.1631 2.04735 8.03948L3.35875 7.61186C3.73967 7.48765 4.14914 7.6959 4.27312 8.0769L4.2755 8.08422H8.01321V9.08422H4.61634Z",
    fill: "#414141"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.26778 5.97739L3.26143 6.02389C3.15451 6.80662 3.15267 7.60012 3.25595 8.38334L3.26809 8.4754L2.27667 8.60613L2.26453 8.51407C2.1496 7.64253 2.15165 6.75955 2.27063 5.88855L2.27698 5.84205L3.26778 5.97739Z",
    fill: "#414141"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7388 8.46784L12.7452 8.42133C12.8521 7.63861 12.854 6.8451 12.7507 6.06189L12.7385 5.96983L13.7299 5.83909L13.7421 5.93115C13.857 6.80269 13.855 7.68568 13.736 8.55667L13.7296 8.60318L12.7388 8.46784Z",
    fill: "#414141"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.19092 6.29204V5.29204H11.8066V6.29204H4.19092Z",
    fill: "#414141"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.190918 4.99234C0.190918 4.4675 0.616384 4.04204 1.14122 4.04204H2.51989V5.04204H1.19092V9.26149H2.51989V10.2615H1.14122C0.616382 10.2615 0.190918 9.83602 0.190918 9.31119V4.99234Z",
    fill: "#414141"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8109 5.04204H13.4811V4.04204H14.8606C15.3855 4.04204 15.8109 4.46751 15.8109 4.99234V9.31174C15.8109 9.83657 15.3855 10.262 14.8606 10.262H13.7792V9.26204H14.8109V5.04204Z",
    fill: "#414141"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbsChallengeIcon);
export default __webpack_public_path__ + "static/media/ABSChallengeIcon.f148f64174cf55ea00612e907d7e8b38.svg";
export { ForwardRef as ReactComponent };